// Utilitaires pour la gestion des dates

/**
 * Convertit une date ISO en format datetime-local (yyyy-MM-ddThh:mm)
 * @param {string} isoDate - Date au format ISO (ex: "2025-09-25T23:06:00.000Z")
 * @returns {string} - Date au format datetime-local (ex: "2025-09-25T23:06")
 */
export const formatDateForDateTimeLocal = (isoDate) => {
  if (!isoDate) return '';
  const date = new Date(isoDate);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

/**
 * Convertit une date ISO en format date (yyyy-MM-dd)
 * @param {string} isoDate - Date au format ISO (ex: "2025-09-25T23:06:00.000Z")
 * @returns {string} - Date au format date (ex: "2025-09-25")
 */
export const formatDateForDateInput = (isoDate) => {
  if (!isoDate) return '';
  const date = new Date(isoDate);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * Convertit une date datetime-local en format ISO
 * @param {string} dateTimeLocal - Date au format datetime-local (ex: "2025-09-25T23:06")
 * @returns {string} - Date au format ISO (ex: "2025-09-25T23:06:00.000Z")
 */
export const formatDateTimeLocalToISO = (dateTimeLocal) => {
  if (!dateTimeLocal) return null;
  return new Date(dateTimeLocal).toISOString();
};

/**
 * Convertit une date date en format ISO
 * @param {string} dateInput - Date au format date (ex: "2025-09-25")
 * @returns {string} - Date au format ISO (ex: "2025-09-25T00:00:00.000Z")
 */
export const formatDateInputToISO = (dateInput) => {
  if (!dateInput) return null;
  return new Date(dateInput).toISOString();
};
